<template>
  <div>
    <div class="chat-icon" @click="toggleChat">
      <i v-if="!showChat" class="pi pi-comment"></i>
      <i v-else class="pi pi-times"></i>
    </div>
    <transition name="chat-slide">
      <div v-if="showChat" class="chat-container">
        <div class="chat-header">
          Chat Support
          <div class="online-indicator header-online"></div>
          <i class="pi pi-window-minimize minimize-btn" @click="toggleChat"></i>
        </div>
        <div class="chat-messages">
          <div v-for="(message, index) in messages" :key="index">
            <div class="message" :class="{ 'user-message': message.fromUser, 'bot-message': !message.fromUser }">
              <i v-if="message.fromUser" class="pi pi-user user-icon"></i>
              <i v-else class="pi pi-comments bot-icon"></i>
              {{ message.content }}
            </div>
          </div>
          <div v-if="typing" class="typing-indicator">
            I'm typing<span class="dot"></span><span class="dot"></span><span class="dot"></span>
          </div>
        </div>
        <div class="chat-input">
          <input type="text" v-model="userInput" @keyup.enter="sendMessage" :disabled="typing" />
          <i class="pi pi-paper-plane send-btn" @click="sendMessage"></i>
        </div>
      </div>
    </transition>
  </div>
</template>


<script>
export default {
  data() {
    return {
      showChat: false,
      userInput: '',
      typing: false,
      messages: [{ content: 'Hi, ask something...', fromUser: false }],
    };
  },
  methods: {
    toggleChat() {
      this.showChat = !this.showChat;
    },
    scrollToBottom() {
        setTimeout(() => {
            const chatMessages = this.$el.querySelector('.chat-messages');
            chatMessages.scrollTop = chatMessages.scrollHeight;
        }, 0);
    },
    async sendMessage() {
      if (this.userInput.trim() !== '') {
        this.messages.push({ content: this.userInput, fromUser: true });
        this.scrollToBottom();
        this.typing = true;
        this.userInput = '';
        // Qui puoi chiamare la tua API
        const response = await fetch('http://localhost:8000/api/v1/chat', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ chat: this.userInput }),
        });

        const data = await response.json();
    
        // Aggiungi il primo elemento dell'array "data" alla lista dei messaggi
        if (data.data && data.data.length > 0) {
          setTimeout(() => {
            this.messages.push({ content: data.data[0], fromUser: false });
            this.typing = false;
            this.scrollToBottom();
          }, 1000); // Aggiungi un ritardo per simulare il tempo di risposta del bot
        }

        this.userInput = '';
      }
    },
  },
};
</script>


<style scoped>
.chat-icon {
  position: fixed;
  bottom: 20px;
  right: 20px;
  font-size: 1.5rem;
  background-color: #007bff;
  color: #fff;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  z-index: 999;
}

.online-indicator {
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: #28a745;
  border-radius: 50%;
  width: 15px;
  height: 15px;
}

.chat-container {
  position: fixed;
  bottom: 80px;
  right: 20px;
  background-color: #fff;
  border-radius: 5px;
  width: 320px;
  height: 500px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  z-index: 999;
}

.chat-header {
  background-color: #007bff;
  color: #fff;
  font-weight: bold;
  padding: 10px;
  text-align: center;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  position: relative;
}

.chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
}

.chat-input {
  border-top: 1px solid #ccc;
  padding: 10px;
  display: flex;
  align-items: center;
}

input[type='text'] {
  width: 100%;
  border: none;
  outline: none;
  font-size: 14px;
}

.message {
  padding: 5px 10px;
  border-radius: 15px;
  margin-bottom: 5px;
  max-width: 80%;
  word-wrap: break-word;
  display: flex;
  align-items: center;
}

.user-message {
  background-color: #007bff;
  color: #fff;
  align-self: flex-end;
  margin-left: 30px;
}

.bot-message {
  background-color: #f1f1f1;
  color: #333;
  align-self: flex-start;
  margin-right: 30px;
}

.typing-indicator {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 10px;
  font-size: 0.8rem;
  color: #999;
}

.dot {
  background-color: #999;
  border-radius: 50%;
  width: 6px;
  height: 6px;
  margin: 0 2px;
  animation: blink 1.4s infinite both;
}

.dot:nth-child(2) {
  animation-delay: 0.2s;
}

.dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes blink {
  0% {
    opacity: 0.2;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: 0.2;
  }
}
.chat-slide-enter-active,
.chat-slide-leave-active {
  transition: all 0.3s ease;
}

.chat-slide-enter,
.chat-slide-leave-to {
  transform: translateY(100%);
  opacity: 0;
}

.minimize-btn {
  position: absolute;
  top: 5px;
  right: 10px;
  font-size: 1.2rem;
  cursor: pointer;
}

.header-online {
  position: absolute;
  top: 12px;
  left: 90px;
}

.send-btn {
  font-size: 1.2rem;
  margin-left: 5px;
  cursor: pointer;
}

.user-icon,
.bot-icon {
  font-size: 0.8rem;
  margin-right: 5px;
}

.user-icon {
  color: #fff;
}

.bot-icon {
  color: #333;
}
</style>


